/* eslint-disable import/no-extraneous-dependencies */
import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import AOS from 'aos';
import Loader from './components/Loader';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';

const Home = lazy(() => import('./pages/Home'));
const HowToBuy = lazy(() => import('./pages/HowToBuy'));

function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <BrowserRouter>
      <Navbar />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/how-to-buy" element={<HowToBuy />} />
        </Routes>
        <Toaster />
      </Suspense>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
